// Runtime detection of the execution context.
// - Native app  = PWA installed on device OR Trusted Web Activity (Android) OR standalone iOS.
// - Web         = classic browser tab with URL bar visible.
//
// We use this to hide the web-only footer, hide Mollie payment (Play Store forbids
// non-Play billing for digital goods on Android), and route Premium via Google Play
// Billing when we ship that integration.
export function isNativeApp() {
  if (typeof window === "undefined") return false;
  try {
    // Android TWA / installed PWA / desktop PWA
    if (window.matchMedia?.("(display-mode: standalone)").matches) return true;
    if (window.matchMedia?.("(display-mode: fullscreen)").matches) return true;
    if (window.matchMedia?.("(display-mode: minimal-ui)").matches) return true;
    // iOS home-screen PWA
    if (window.navigator?.standalone === true) return true;
    // TWA sends this referrer
    if (document.referrer?.startsWith("android-app://")) return true;
    // Explicit query flag we can set from Bubblewrap/PWABuilder start_url
    if (window.location.search?.includes("source=pwa")) return true;
    if (window.location.search?.includes("utm_source=twa")) return true;
  } catch {
    /* no-op */
  }
  return false;
}

export function paymentProvider() {
  return isNativeApp() ? "play-billing" : "mollie";
}
